<div *ngIf="Mode == 'Student'">
	<caass-personselector [AudienceID]="1"></caass-personselector>
</div>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content"></div>

			<!-- <div class="RadioBorder">
				<h4 style="text-align: center">Mode:</h4>

				<div class="RadioGrid">
					<input type="radio" class="RAD" value="Student" id="Student" name="Mode" [(ngModel)]="Mode" />
					<label for="Student">By Student</label>

					<input type="radio" class="RAD" value="Parent" id="Parent" name="Mode" [(ngModel)]="Mode" style="margin-left: 15px" />
					<label for="Parent">By Parent</label>
				</div>
			</div> -->

			<div *ngIf="Mode == 'Student'">
				<caass-parent-portal-by-student-mode> </caass-parent-portal-by-student-mode>
			</div>

			<div *ngIf="Mode == 'Parent'">
				<caass-parent-portal-by-parent-mode></caass-parent-portal-by-parent-mode>
			</div>
		</div>
	</div>
</div>
